import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ccd9a86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "containerMain" }
const _hoisted_2 = { class: "contentMain" }

import ShowHeader from "@/components/homeComponents/ShowHeader.vue";
import AsideContent from "@/components/homeComponents/AsideContent.vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const route = useRoute();

const key = route.meta.activeMenuName as string;

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_KeepAlive, null, [
      _createVNode(ShowHeader)
    ], 1024)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_router_view, { key: _unref(key) }))
          ]),
          _: 1
        }),
        _createVNode(_component_el_aside, null, {
          default: _withCtx(() => [
            _createVNode(AsideContent)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})